module.exports = __webpack_public_path__ + "img/instagram.a3bca7b9.svg";